import { getUID } from '@redviking/argonaut-util/src/getUID';
import { getAllAppletVariables } from '@redviking/argonaut-util/src/mes/appletUtil';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';
import { getSocketTypeForVarId } from '../socket-var-helpers';
import { defineControlOpts } from '../../controls/FlowNodeControl';
import { defaultControlUpdateValueHandler } from '@redviking/argonaut-core-ui/src/applet/design/flows/controls/control-event-handler';

export const varAssignedNodeSpec: NodeSpec<NodeCfg<'varAssigned'>> = {
    requiredSockets: (_, _availableInputSockets, availableOutputSockets) => ({
        required: [],
        conditionallyRequired: [
            {
                kind: 'or',
                availableOptions: availableOutputSockets,
            },
        ],
    }),
    cfg: () => ({ controlValues: { changesOnly: false, varId: '' }, id: getUID(), kind: 'varAssigned', disabled: false, width: 210 }),
    controls: nodeCfg => ({
        changesOnly: defineControlOpts({
            cfg: { kind: 'boolean', label: 'Changes Only' },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.changesOnly,
        }),
        varId: defineControlOpts({
            cfg: {
                kind: 'selectVar',
                label: 'Variable',
            },
            on: { 'update:value': defaultControlUpdateValueHandler },
            value: nodeCfg.controlValues.varId,
        }),
    }),
    inputs: () => ({}),
    kindLabel: 'Variable Assigned',
    nodeCategory: 'variable',
    outputs: nodeCfg => ({
        trigger: { socket: 'event', label: 'Trigger' },
        newValue: { socket: getSocketTypeForVarId(nodeCfg.controlValues.varId), label: 'New Value' },
        oldValue: { socket: getSocketTypeForVarId(nodeCfg.controlValues.varId), label: 'Old Value' },
    }),
    validator: (node, appletDesignVersionConfig) => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.varId) {
            errors.varId = 'Variable is required';
        }
        const allAppletVariables = getAllAppletVariables(appletDesignVersionConfig);
        if (!allAppletVariables[node.controlValues.varId]) {
            errors.varId = 'Variable is not a valid variable';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
